import styled from 'styled-components';

/**
 * @since 8.28.0
 */
var ListboxOptionLabel = /*#__PURE__*/styled.div.withConfig({
  displayName: "ListboxOptionLabel",
  componentId: "c11n-8-111-1__sc-11c6ubi-0"
})([""]);
ListboxOptionLabel.displayName = 'ListboxOptionLabel';

/** @component */
export { ListboxOptionLabel };